import { NgClass } from '@angular/common';
import { booleanAttribute, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'mdc-list-chips',
  imports: [MatChipsModule, MatIconModule, NgClass],
  template: `
    <mat-chip-set [ngClass]="{ '[&>div]:flex-nowrap': nowrap }">
      @for (item of options; track item) {
        <mat-chip-option
          [removable]="removable"
          [selectable]="selectable"
          (removed)="onRemove.emit(item)"
          [class]="customClass">
          <div [class.truncate]="truncate">
            {{ label ? item[label] : item }}
          </div>
          @if (removable) {
            <mat-icon matChipRemove>cancel</mat-icon>
          }
        </mat-chip-option>
      }
    </mat-chip-set>
  `
})
export class MdcListChipsComponent<T> {
  @Input() options: T[] = [];
  @Input() label: keyof T;
  @Input({ transform: booleanAttribute }) removable = false;
  @Input({ transform: booleanAttribute }) selectable = false;
  @Input({ transform: booleanAttribute }) truncate = false;
  @Input({ transform: booleanAttribute }) nowrap = false;
  @Input() customClass = '';
  @Output() onRemove = new EventEmitter<T>();
}
